<!--
 * @Author: your name
 * @Date: 2022-03-30 17:40:42
 * @LastEditTime: 2022-05-26 14:01:05
 * @LastEditors: Jokersora 674077946@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\components\HelloWorld.vue
-->
<template>
  <div class="root" v-if="show">
    <div class="root-container">
      <div class="tit">联系我们 Contact Us</div>
      <!-- <div class="tel">
        <div>0512 - 68367076</div>
      </div> -->
      <div class="phone">
        <div>13773138080(陈明)</div>
      </div>
      <div class="position">
        <a target="_blank" href="http://map.baidu.com/?latlng=31.337672,120.78234&title=江苏明耀工程技术有限公司&content=苏州工业园区凤里街345号2号楼C座&autoOpen=true&l">江苏省苏州市工业园区凤里街345号2号楼C座</a>
      </div>
    </div>
    <a class="copy-right" target="blank" href="http://beian.miit.gov.cn/">{{icp}}</a>
    <a class="ba" target="blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002003992">苏公网安备 32059002003992号</a>
  </div>
</template>

<script>
export default {
  name: "Root",
  data:()=>{
    return {
      show:false,
      icp:""
    }
  },
  beforeMount(){
    this.icp=window.icp||'';
  },
  beforeDestroy(){
    clearTimeout(this.timeout);
  },
  mounted(){
    let _this=this;
    this.timeout=setTimeout(()=>{
      _this.show=true;
    },1000)
  }
};
</script>
<style scoped lang="less">
.root{
  background-color:rgb(24,32,41);
  margin-top:1rem;
  color:white;
}
.root-container{
  padding:1rem;
  .tit{
    font-size: 1.3rem;
  }
}
.root-container>div{
  margin:0.5rem 0 0.5rem 0;
}
.tel>div::before{
  content:"";
  width:1rem;
  height:1rem;
  vertical-align: middle;
  margin-right: 0.5rem;
  display:inline-block;
  background-image: url(../assets/icons/tel.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}
.phone>div::before{
    content:"";
  width:1rem;
  height:1rem;
  vertical-align: middle;
  margin-right: 0.5rem;
  display:inline-block;
  background-image: url(../assets/icons/phone.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}
.position>a::before{
    content:"";
  width:1rem;
  height:1rem;
  vertical-align: middle;
  margin-right: 0.5rem;
  display:inline-block;
  background-image: url(../assets/icons/position.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
}
.position>a{
  color:white;
}
.position>a:link{
  color:white;
}
.ba::before{
  content:"";
  display:inline-block;
  background-image:url(../assets/icons/police.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size:100% 100%;
  width:1rem;
  height:1rem;
}
.ba{
  margin-left:1rem;
}
</style>
